export const replaceText = (
  body: string,
  replacers: Record<string, string>,
): string => {
  return Object.keys(replacers).reduce((result, key) => {
    const placeholder = new RegExp(`${key}`, 'g');
    return result.replace(placeholder, replacers[key]);
  }, body);
};
